import React, { FC } from 'react';

import { Box, BoxProps, useMediaSwitch } from 'Modules/ui3';


export type ContainerBoxProps = BoxProps;

export const ContainerBox: FC<ContainerBoxProps> = ({
    children, ...props
}) => (
    <Box
        p={useMediaSwitch(8, 6, 4)}
        bgcolor='grayscale.shade0'
        borderRadius={8}
        overflow='hidden'
        {...props}
    >
        {children}
    </Box>
);
